function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isFunction } from '@cloud-sn/v-utils';
import { DEFAULT_FIELD_NAMES } from '../utils';
var DefaultChildren = DEFAULT_FIELD_NAMES.children;
export default {
  methods: {
    canAsync: function canAsync(parent) {
      var loadData = this.loadData;

      if (!parent) {
        return isFunction(loadData);
      }

      var children = parent[DefaultChildren];
      var isParent = parent.isParent,
          isLoaded = parent.isLoaded,
          isLoading = parent.isLoading;
      var isCanLoad = isParent && !isLoaded && !isLoading;
      return isCanLoad && isFunction(loadData) && (!isArray(children) || children.length === 0);
    },
    asyncNode: function asyncNode(parent) {
      var canAsync = this.canAsync,
          loadData = this.loadData,
          addNodes = this.addNodes;

      if (!canAsync(parent)) {
        return Promise.resolve(null);
      }

      var np = parent;
      var params;

      if (np) {
        np.isLoading = true;
        np.isLoaded = false;
        params = _objectSpread({}, np.originNode);
      }

      return Promise.resolve(loadData(params)).then(function (data) {
        if (np) {
          np.isLoaded = true;
          np.isLoading = false;
        }

        return addNodes(data, np);
      });
    }
  }
};